//external import
import React, { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'

//internal import
import DatatTable from '../../Table'
import styles from './ViewFeedbackForm.module.css';

const tableStyles = {
    width: " 100%",
    height: "auto",
    minWidth: "0"
}


export default function CloseFeedbackForm(props) {
    const { i18n, t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');
    // const [selectedShowOption, setSelectedShowOption] = useState(10);
    const [filteredRows, setFilteredRows] = useState([]);
    const role = useSelector((state) => state.role.userCurrRole.description);
    console.log(role);

    const columnData = props.columnData;
    const rowsData = props.rowsData;

    const handlePaginationChange = (pageSize, page) => {
        console.log(`Selected page size: ${pageSize}, Page: ${page}`);
    };


    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);

        if (searchTerm.trim() === '') {
            setFilteredRows([]);
        } else {
            const filteredData = rowsData.filter((row) =>
                Object.values(row).some((value) =>
                    value !== null && value !== undefined && String(value).toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
            setFilteredRows(filteredData);
        }
    };

    const tableData = { columnData: columnData, rowsData: rowsData };
    const availableShowOptions = [10, 25, 50, 100];

    const roleTitles = {
        ROLE_SPOC: t('title.new.feedbacklist.CloseFeedback'),
        ROLE_INTERNAL: t('title.new.feedbacklist.viewFeedback'),
        ROLE_CUSTOMER: t('title.new.feedbacklist.viewFeedback'),
    };
    const title = roleTitles[role] || '';

    return (
        <div className="container" style={{ border: '1px solid #ccc', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', padding: '20px', width: '100%', maxWidth: '100%' }}>
            <h1>{title}</h1>
            <h1 style={{ borderBottom: '1px solid', paddingBottom: '10px' }}></h1>

            <div className={styles.searchBar} style={{ justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                    {t('general.datatable.sSearch.label')}
                    &nbsp;
                    <div className="col-auto" style={{ marginRight: '10px' }}>
                        {/* <input className={styles.searchText + " " + 'form-control'} type="text" id="searchText" placeholder={t('feedback.viewFeedback.searchbar')} value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value), handleSearch(e.target.value) }} /> */}
                    </div>


                </div>
            </div>
            <br />
            {searchTerm.trim() === '' ? (
                <DatatTable tableStyles={tableStyles} tableData={tableData} />
            ) : (
                filteredRows.length === 0 ? (
                    <p>{t('general.datatable.sZeroRecords.label')}</p>
                ) : (
                    <DatatTable tableStyles={tableStyles} tableData={{ columnData, rowsData: filteredRows }} />
                )
            )}
        </div>
    );
}
